import { GENERATE_AUTH_TOKEN, PAYMENT_SERVER_URL } from '../config';

// Fetch al server de pagos de Atlas con el auth de Atlas SIEMPRE puesto.
// Usar SIEMPRE esto para pegarle al payment server (en vez de `fetch` pelado) →
// garantiza que todo request lleve el `Authorization: <GENERATE_AUTH_TOKEN>` que
// el server valida, y el `Content-Type: application/json` por defecto.
//
// `pathOrUrl` puede ser un path relativo ('/rebill/change-plan') o una URL
// completa (se usa tal cual). Headers extra pisan los defaults si hace falta.
export function paymentServerFetch(
  pathOrUrl: string,
  init: RequestInit = {},
): Promise<Response> {
  const url = /^https?:\/\//.test(pathOrUrl)
    ? pathOrUrl
    : `${PAYMENT_SERVER_URL}${pathOrUrl}`;
  return fetch(url, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: GENERATE_AUTH_TOKEN,
      ...(init.headers || {}),
    },
  });
}
